import {Component, Input, OnInit} from '@angular/core';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {AppComponent} from '../app.component';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {MatDialog} from '@angular/material/dialog';
import {ImportFileDialogComponent} from './import-file-dialog/import-file-dialog.component';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {interval} from 'rxjs';

@Component({
    selector: 'app-createfromopenapi',
    templateUrl: './createfromopenapi.component.html',
    styleUrls: ['./createfromopenapi.component.css']
})
export class CreatefromopenapiComponent implements OnInit {
    title = 'app';
    code: string;
    deploymentPlan: any;
    origDeploymentPlan: any;
    apiExecutorPlans: any;
    entityPlans: any;
    dataMigrationPlans: any;
    applicationData: any;
    categoriesData: any;
    showInputPanel = true;
    showNextPanel = false;
    showDeploymentPlan = false;
    databases: any;
    defaultDatabase = 'default';
    executorTypes = [
        {display_name: 'Business Logic API', executor_type: 'BUSINESSLOGIC'},
        {display_name: 'SQL Query API', executor_type: 'SQLQUERY'},
        {display_name: 'Workflow API', executor_type: 'WORKFLOW'},
        {display_name: 'PLSQL API', executor_type: 'PLSQL'},
        // {display_name: 'Third Party API', executor_type: 'THIRDPARTY'},
    ];

    specificationInput = '3.0';
    specificationTypes = [
        {display_name: 'Swagger 2.0', specification: '2.0'},
        {display_name: 'OpenAPI 3.0', specification: '3.0'},
        {display_name: 'OpenAPI 3.1', specification: '3.1'}
    ];
    options = {
        theme: 'vs-dark',
        language: 'yaml',
        automaticLayout: true
    };
    loading = false;

    componentLoading = true;
    editFlag = false;
    apiExecutors: any;
    entities: any;
    applicationEntries: any;

    executorKeys = ['dataroot', 'executor_type', 'executor_name', 'executor_version', 'executor_display_name', 'executor_description', 'executor_category', 'executor_category_group', 'service_provider', 'executor_scope', 'partner', 'account_id', 'executor_method_type', 'apiUrl', 'pathParams', 'queryParams', 'headers', 'authModel', 'requestBody', 'prerequisites', 'published', 'scopeOfAccess', 'registeredAsIs']

    constructor(private confPost: ConfService,
                private _service: ConnecttocrudService,
                private appComp: AppComponent,
                public dialog: MatDialog,
                public platform: LeftpanelComponent,
                private router: Router,
                private location: Location,
                private route: ActivatedRoute) {
    }

    @Input() enableEditor = false;
    // onInit(editor) {
    //   let line = editor.getPosition();
    // //  this.enableMonacoEditor = true;
    // }
    ngOnInit() {
        if (this.location['_platformLocation'].location.pathname === '/application/edit') {
            this.editFlag = true;
            this.route.queryParams
                .subscribe(async params => {
                    if (params.title && params.title !== '' && params.version && params.version) {
                        this.deploymentPlan = {
                            executorModelDeploymentPlans: [],
                            entityDeploymentPlans: [],
                            application: {},
                            categories: [],
                            requestModel: {
                                transformOption: 'openapi'
                            }
                        };

                        this.confPost.getData('services', 'services', 'v1', 'application', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&title=' + params.title + '&version=' + params.version).subscribe(async resp => {

                            this.applicationEntries = resp;
                            if (this.applicationEntries && this.applicationEntries[0]) {
                                this.applicationData = this.applicationEntries[0];
                                this.categoriesData = this.applicationData.categories;
                                if (!this.applicationData.license) {
                                    this.applicationData['license']['name'] = '';
                                    this.applicationData['license']['url'] = '';
                                }
                                if (!this.applicationData.license) {
                                    this.applicationData['license']['name'] = '';
                                    this.applicationData['license']['url'] = '';
                                }
                                if (!this.applicationData.servers) {
                                    this.applicationData['servers'] = [];
                                }
                                if (!this.applicationData.summary) {
                                    this.applicationData['summary'] = '';
                                }
                                this.deploymentPlan.application = this.applicationData;
                                this.deploymentPlan.categories = this.categoriesData;

                                if (this.categoriesData) {
                                    const categories = this.categoriesData.map(a => a.name);
                                    let isError = false;
                                    if (categories.length > 0) {
                                        await this.confPost.getApiExecutorsByPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'), 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&executor_category.in=' + categories.join(',')).toPromise().then(data => {
                                            this.apiExecutors = data;
                                            const executorPayload = [];
                                            this.apiExecutors.forEach(apiExecutor => {
                                                const executor = {
                                                    isAvailable: true,
                                                    apiExecutor: apiExecutor
                                                };
                                                executorPayload.push(executor);
                                            });
                                            this.deploymentPlan.executorModelDeploymentPlans = executorPayload;
                                        }, error => {
                                            isError = true;
                                            this.router.navigateByUrl('/controlplane');
                                            this.platform.openSnackBar('Error while retrieving executors for Application.', 'Error', {
                                                duration: 10000,
                                                verticalPosition: 'top',
                                                horizontalPosition: 'center'
                                            });
                                        });
                                    }


                                    await this.confPost.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data1 => {
                                        this.entities = data1;
                                    }, error => {
                                        isError = true;
                                        this.router.navigateByUrl('/controlplane');
                                        this.platform.openSnackBar('Error while retrieving Entities for Application.', 'Error', {
                                            duration: 10000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    });

                                    const entityPayload = [];
                                    this.entities.forEach(entityModel => {
                                        if (categories.includes(entityModel.category)) {
                                            const entity = {
                                                isAvailable: true,
                                                entity: entityModel
                                            };
                                            entityPayload.push(entity);
                                        }
                                    });
                                    this.deploymentPlan.entityDeploymentPlans = entityPayload;
                                    if (!isError) {
                                        this.apiExecutorPlans = this.deploymentPlan.executorModelDeploymentPlans;
                                        this.entityPlans = this.deploymentPlan.entityDeploymentPlans;
                                        for (const entity of this.entityPlans) {
                                            entity['deploy_api'] = true;
                                            if (entity.isAvailable) {
                                                entity['deploy_api'] = false;
                                            }
                                            // entity['override_api'] = entity.isAvailable;
                                        }

                                        for (const executor of this.apiExecutorPlans) {
                                            executor['deploy_api'] = true;
                                            if (executor.isAvailable) {
                                                executor['deploy_api'] = false;
                                            }
                                            // executor['override_api'] = executor.isAvailable;
                                        }
                                        this.componentLoading = false;
                                        this.showNextPanel = true;
                                    }

                                }
                            } else {
                                this.router.navigateByUrl('/controlplane');
                                this.platform.openSnackBar('Application not found.', 'Error', {
                                    duration: 10000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }

                        }, error => {
                            this.router.navigateByUrl('/controlplane');
                            this.platform.openSnackBar('Error while retrieving Application.', 'Error', {
                                duration: 10000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                    } else {
                        this.router.navigateByUrl('/controlplane');
                        this.platform.openSnackBar('Error while retrieving Application.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                });
        } else {
            this.componentLoading = false;
            this.enableEditor = true;
            this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(async data => {
                await this.platform.updateIsNoSQLForMongo(data);
                this.databases = data;
            });
        }
    }

    buildDeploymentPlanForOpenApi() {
        this.loading = true;
        if (this.code === undefined) {
            this.loading = false;
            alert('Enter Specification');
        } else {
            this.confPost.buildDeploymentPlanForOpenApi(localStorage.getItem('partner'), localStorage.getItem('account'), this.code.toString(), this.specificationInput).subscribe(data => {
                this.deploymentPlan = data;
                if (this.deploymentPlan) {
                    this.apiExecutorPlans = this.deploymentPlan.executorModelDeploymentPlans;
                    this.entityPlans = this.deploymentPlan.entityDeploymentPlans;
                    this.dataMigrationPlans = this.deploymentPlan.dataMigrationPlans;
                    this.applicationData = this.deploymentPlan.application;
                    this.categoriesData = this.deploymentPlan.categories;
                    if (!this.applicationData.license) {
                        this.applicationData['license']['name'] = '';
                        this.applicationData['license']['url'] = '';
                    }
                    if (!this.applicationData.license) {
                        this.applicationData['license']['name'] = '';
                        this.applicationData['license']['url'] = '';
                    }
                    if (!this.applicationData.servers) {
                        this.applicationData['servers'] = [];
                    }
                    if (!this.applicationData.summary) {
                        this.applicationData['summary'] = '';
                    }
                    this.showDeploymentPlan = true;
                    this.showInputPanel = false;
                    this.showNextPanel = false;

                    for (const entity of this.entityPlans) {
                        entity['deploy_api'] = true;
                        if (entity.isAvailable) {
                            entity['deploy_api'] = false;
                        }
                        // entity['override_api'] = entity.isAvailable;
                    }

                    for (const executor of this.apiExecutorPlans) {
                        executor['deploy_api'] = true;
                        if (executor.isAvailable) {
                            executor['deploy_api'] = false;
                        }
                        // executor['override_api'] = executor.isAvailable;
                    }
                } else {
                    this.loading = false;
                }
            }, error => {
                this.loading = false;
                this.platform.handleErrorGracefully(error, 'Please enter a valid YAML input.');
            });
        }
    }

    updateTypeForExecutor(event, i) {
        const type = event.value;
        // Object.keys(this.deploymentPlan.executorModelDeploymentPlans[i].apiExecutor).forEach((key) => this.executorKeys.includes(key) || delete this.deploymentPlan.executorModelDeploymentPlans[i].apiExecutor[key]);
        if (type === 'SQLQUERY' || type === 'PLSQL') {
            this.deploymentPlan.executorModelDeploymentPlans[i].apiExecutor['executors'] = [
                {
                    'database': {
                        'database_name': '',
                        'database_type': ''
                    },
                    'query': ''
                }
            ];
        }
    }

    refreshComponent() {
        this.showNextPanel = false;
        this.showDeploymentPlan = true;
        this.showInputPanel = false;
        this.loading = false;
    }

    openFileUploadDialog() {
        const dialogRef = this.dialog.open(ImportFileDialogComponent, {
            height: '50%',
            width: '50%'
        });
        dialogRef.afterClosed().subscribe(async file => {
            if (file) {
                const reader = new FileReader();
                // this.modeler.importXML(file, value => this.handleError(value));
                reader.addEventListener('load', (event: any) => {
                    this.code = event.target.result.toString();
                });
                reader.readAsText(file);
            }
        });
    }

    toggleOverride(event, api) {
        api.deploy_api = event.checked;
    }

    toggleOverrideForSelected(event, api) {
        if (api.isAvailable) {
            api.override_api = event.checked;
        }
    }

    getSpecificationDisplayName() {
        const that = this;
        return this.specificationTypes.filter(function(e) { return e.specification === that.specificationInput; })[0].display_name;
    }

    createPaddingRight() {
        document.getElementById('view:openApi').style.paddingRight = '400px';
    }

    removePaddingRight() {
        document.getElementById('view:openApi').style.paddingRight = '0px';
    }
}
